export default __webpack_public_path__ + "static/media/tp-transportes-water.05486858.svg";